import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class successDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open:false
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.open !== this.state.open){
            this.setState({
                open: nextProps.open
            })
        }
    }

    handleOK = () =>{
        this.setState({ open: false });
        if(this.props.okFunction) this.props.okFunction();
    };

    render() {
        return (
            <Dialog
                open={this.state.open}
                TransitionComponent={Transition}
                keepMounted
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title">
                    リクエスト完了
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        荷受書のアップロードリクエストを受け付けました。<br />
                        一覧画面へ戻ります。<br />
                        <span style={{display:'inline-block', fontSize:'80%', marginTop:20, color:'#f44336'}}>
                            ※リクエストの状況は、「受付状況」でご確認いただけます
                        </span>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleOK} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}
successDialog.propTypes = {
    open:PropTypes.bool,
    okFunction:PropTypes.func,
};
successDialog.defaultProps = {
    open:false
};
export default successDialog;


// WEBPACK FOOTER //
// ./src/routes/upload-receipt-new/components/success-dialog.js